import mainLogo from '../../images/Vecol/vecol_logo_main.png';
import squareLogo from '../../images/Vecol/vecol_logo_alt_azul.png';
import bannerLogoWhite from '../../images/Vecol/vecol_logo_alt_branco.png';
import banner01 from '../../images/Vecol/mainbanner_bg_vecol_2.jpg';
import banner02 from '../../images/Vecol/vecol_bg_2.1.jpg';
import banner03 from '../../images/Vecol/vecol_bg_1.1.jpg';
import bannerAboutUs from '../../images/Vecol/vw_brand_bg.jpg';
import car123 from '../../images/Vecol/123_polo.jpg';
import box123 from '../../images/Vecol/123_vecol.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Vecol',
    defaultStoreLink: 'pecasvecol.com.br',
    defaultContactEmail: 'ecommerce@vecol.com.br',
    whatsappNumber: '14 99615 4156',
    CNPJname: 'VECOL VEICULOS LTDA',
    CNPJ: '47.333.034/0001-61',
    CNPJaddress: 'Av Professor Alberto Vollet Sachs, 3555 - Piracicaba, SP - 13.418-000',
    launchDate: '07/09/2024',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "VECOL VW",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        {
            name: 'Freios',
            img: 'tabFreios',
            products: SliderProducts.Freios
        },
        // {
        //     name: 'Roupas',
        //     img: 'tabRoupas',
        //     products: SliderProducts.Roupas
        // }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: '',
    bannerBrands: '',
    aboutUsBg: bannerAboutUs,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Vecol</span>.',
    aboutUs: {
        title: 'Quem somos',
        content: [
            'Atualmente o Grupo Vecol é uma das maiores redes de concessionárias exclusivas Volkswagen do Brasil.',
            'Presente nas cidades de Piracicaba, Botucatu, São Manuel, Lençóis Paulista, Jaú, Ibitinga, Bebedouro, Barretos, Colina e Jaboticabal.',
            'O Grupo Vecol tem a certificação ATC Volkswagen. Um programa desenvolvido pela Volkswagen do Brasil voltado para  excelência no atendimento dos nossos clientes no departamento de pós-venda. Nosso Grupo também foi um dos primeiros selecionados pela Volkswagen do Brasil para implantação do programa Dealer Qualification, programa que busca a excelência no  atendimento dos clientes de veículos novos e seminovos.'
        ],
        link: 'https://vecolveiculos.com.br/',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/vecolmultimarcas/',
        Facebook: 'https://www.facebook.com/vecolveiculos',
        LinkedIn: 'https://www.linkedin.com/company/vecol-ve%C3%ADculos-s-a/',
        Youtube: 'https://www.youtube.com/channel/UCkr1eOPE8inzRGpPID-10BQ',
        Twitter: '',
    },

    footerContent: [],
}